import dynamic from 'next/dynamic';
import { createContext } from 'react';

const EmojiPicker = dynamic(
  () => {
    return import('emoji-picker-react');
  },
  { ssr: false },
);

export const EmojiPickerContext = createContext(EmojiPicker);
